import styled, { css } from 'styled-components';

import {
  colorBlack200,
  colorGrey100,
  colorPrimary,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryDesktopLargeMin,
  mediaQueryTabletMin,
  mediaQueryTabletSmallMin,
} from '@/styleUtils';

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media ${mediaQueryDesktopLargeMin} {
    gap: 24px;
  }
`;

export const MainFilters = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  grid-template-areas:
    'main-1 main-1'
    'main-2 main-2'
    'main-3 main-3'
    'main-4 main-4';
  grid-template-columns: 1fr 1fr;

  & > * {
    min-width: 0;
  }

  & > [data-area='main-4'] {
    display: flex;
    gap: 20px;
  }

  @media ${mediaQueryTabletSmallMin} {
    grid-template-areas:
      'main-1 main-2'
      'main-3 main-3'
      'main-4 main-4';
    grid-template-columns: 1fr 1fr;
  }

  @media ${mediaQueryTabletMin} {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas:
      'main-1 main-2 main-3'
      'main-4 main-4 main-4';
  }

  @media ${mediaQueryDesktopLargeMin} {
    grid-template-columns: 256px 1fr 1fr 309px;
    grid-template-areas: 'main-1 main-2 main-3 main-4';
  }
`;

export const GridItem = styled.div.attrs(({ $area }) => ({
  'data-area': $area,
}))`
  display: flex;
  grid-area: ${({ $area }) => $area};
`;

export const SubmitBtn = styled.button`
  align-items: center;
  background-color: ${colorPrimary};
  border-radius: 4px;
  border: 0;
  color: ${colorWhite};
  display: flex;
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  line-height: 16px;
  outline: none;
  transition: 0.2s;
  width: 100%;

  &:hover,
  &:focus {
    opacity: 0.8;
    box-shadow: rgba(27, 110, 16, 0.36) 0 4px 6px;
  }

  &:active {
    opacity: 0.9;
  }
`;

export const ProductsCount = styled.span`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  margin-left: 8px;
  min-height: 28px;
  min-width: 28px;
  white-space: nowrap;
  width: 28px;
`;

export const ClearFiltersButton = styled.button`
  background-color: transparent;
  display: flex;
  height: 48px;
  justify-content: center;
  align-items: center;
  color: ${colorBlack200};
  font: normal 400 14px/24px ${fontFamilyPrimary};
  gap: 9px;
  transition: 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const HiddenFilters = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  padding: 20px 0 0;
  border-top: 1px solid ${colorGrey100};
  ${({ $filtersNotEmpty }) => ($filtersNotEmpty ? 'hd-11' : null)};
  grid-template-columns: 1fr;
  ${({ $filtersNotEmpty }) => {
    if ($filtersNotEmpty) {
      return css`
        grid-template-areas:
          'hd-0'
          'hd-1'
          'hd-2'
          'hd-3'
          'hd-4'
          'hd-5'
          'hd-6'
          'hd-7'
          'hd-8'
          'hd-9'
          'hd-10'
          'hd-11';
      `;
    }

    return css`
      grid-template-areas:
        'hd-0'
        'hd-1'
        'hd-2'
        'hd-3'
        'hd-4'
        'hd-5'
        'hd-6'
        'hd-7'
        'hd-8'
        'hd-9'
        'hd-10';
    `;
  }};

  & > * {
    min-width: 0;
  }

  & > [data-area='hd-0'] {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  & > [data-area='hd-11'] {
    display: flex;
    justify-content: center;
  }

  @media ${mediaQueryTabletSmallMin} {
    grid-template-columns: 1fr 1fr;
    ${({ $filtersNotEmpty }) => {
      if ($filtersNotEmpty) {
        return css`
          grid-template-areas:
            'hd-0 hd-0'
            'hd-1 hd-2'
            'hd-3 hd-4'
            'hd-5 hd-6'
            'hd-7 hd-8'
            'hd-9 hd-10'
            'hd-11 hd-11';
        `;
      }

      return css`
        grid-template-areas:
          'hd-0 hd-0'
          'hd-1 hd-2'
          'hd-3 hd-4'
          'hd-5 hd-6'
          'hd-7 hd-8'
          'hd-9 hd-10';
      `;
    }};
  }

  @media ${mediaQueryTabletMin} {
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas:
      'hd-0 hd-0 hd-0'
      'hd-1 hd-2 hd-3'
      'hd-4 hd-5 hd-6'
      'hd-7 hd-8 hd-9'
      'hd-10 hd-11 hd-11';

    & > [data-area='hd-11'] {
      justify-content: right;
    }
  }

  @media ${mediaQueryDesktopLargeMin} {
    padding: 24px 0 0;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas:
      'hd-0 hd-0 hd-0 hd-0'
      'hd-1 hd-2 hd-3 hd-4'
      'hd-5 hd-6 hd-7 hd-8'
      'hd-9 hd-10 hd-11 hd-11';

    & > [data-area='hd-0'] {
      margin-bottom: 4px;
    }
  }
`;
